import { Opco } from "types/Opco";

const opcoList: Opco[] = ["es", "de", "gb", "eg", "pt", "lw", "za", "ro", "cz", "tr", "gr", "nl"];

const getOpco = (): Opco => {
  const pathSplits = window.location.pathname.split("/").filter(Boolean);

  const opco = pathSplits.find((segment) => opcoList.includes(segment as Opco));

  // since it's guaranteed to exist, assert type
  return opco as Opco;
};

export default getOpco;
